import { render, staticRenderFns } from "./ResubmitList.vue?vue&type=template&id=6d97ced1&scoped=true&"
import script from "./ResubmitList.vue?vue&type=script&lang=js&"
export * from "./ResubmitList.vue?vue&type=script&lang=js&"
import style0 from "./ResubmitList.vue?vue&type=style&index=0&id=6d97ced1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97ced1",
  null
  
)

export default component.exports